export enum ROLES {
    ADMIN = "admin",
    SUPER = "superAdmin",
    ADMON = "admon",
}
